import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { PropTypes } from 'prop-types';
import {
    AppBar,
    Button,
    Popper,
    Tab,
    Tabs,
    TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import LensIcon from '@material-ui/icons/Lens';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';

import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/styles';
import indigo from '@material-ui/core/colors/indigo';
import { createTheme, MenuItem, Select } from '@material-ui/core';

import { useRecoilState, useRecoilValue } from 'recoil';

import './DrilldownAndDetailSearch.css';

import Constant from '@/common/constant/Constant';

import Utils from '@/common/utils/utils';
import LoadingPanel from '../common/LoadingPanel';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';

import {
    convertOptionsDataFromStructure,
    getOptionListFromDrillDownData,
    handleChangeSearchDateAgoUnit,
    handleChangeSearchDateAgoValue,
    handleChangeSearchPdfOption,
    handleChangeSortType,
    isSelectedDrilldownField,
    isSelectedOption,
    onChangeSearchDateType,
    removeTypingDate,
    selectDrilldown,
    showAllDrillDownItem
} from './handler/DrilldownAndDetailSearchHandler';
import { getSelectedDrilldownOptionDisplayLabel, getDrilldownChildDisplayLabel, getDrilldownParentDisplayLabel } from '@/common/utils/DrilldownDisplayUtils';
import {
    helpdeskViewStructureAtom,
    projectInuseViewStructureAtom,
    helpdeskDefaultSelectedOptionAtom,
    projectInuseDefaultSelectedOptionAtom,
    isLoadingHelpdeskDrillDownDataAtom,
    isLoadingProjectInuseDrillDownDataAtom,
    helpdeskDrillDownDataAtom,
    projectInuseDrillDownDataAtom,
    helpdeskDefaultDrillDownDataAtom,
    projectInuseDefaultDrillDownDataAtom,
    knowledgeTicketContainAnyAtom,
    knowledTicketNotIncludeAtom,
    destinationPrjIdAtom,
    isLoadingDefaultDrilldownAtom,
} from '@/state/atom/ticketKnowledgeAtom';
import { cloneDeep } from 'lodash';
import { normalizeString, isCheckMethodSimilar, isCheckSortPageNo, isDisplayIconSearchFileAndPageKnowledge } from './handler/ListTicketKnowledgeHandler';
import {
    helpdeskTicketListDefaultDrillDownDataAtom,
    helpdeskTicketListDefaultSelectedOptionAtom,
    helpdeskTicketListDrillDownDataAtom,
    helpdeskTicketListViewStructureAtom,
    helpdeskTicketListIsLoadingDrillDownDataAtom,
    helpdeskTicketLastUserActionAtom,
    helpdeskTicketSearchTagSuggestAtom,
    helpdeskTicketContainAnyAtom,
    helpdeskTicketNotIncludeAtom,
    knowledgeSearchTagSuggestAtom
} from '@/state/atom/ticketAtom';
import { projectInuseDetailAtom, viewKnowledgeProjectSelectedAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { userAtom } from '@/state/atom/userAtom';
import { getPublicAPI } from '@/service/publicService';
import RenderDrilldownTag from './elements/Drilldown/RenderDrilldownTag';
import RenderAutoCompleted from './elements/Drilldown/RenderAutoCompleted';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function DrilldownAndDetailSearch(props) {
    // Subscribe to translation updates so displayed placeholders re-render on language change
    useTranslationSubscription();
    const {
        parentPanel,
        isCustomer,
        API,
    } = props;
    const corporationDetail = useRecoilValue(corporationAtom);

    // tabs
    const [tabSelected, setTabSelected] = useState(Constant.KNOWLEDGE_SEARCH_SCREEN.DRILLDOWN);

    const onChangeTab = (event, newValue) => setTabSelected(newValue);

    let isLoadingAtom;
    let defaultDrillDownDataAtom;
    let drillDownDataAtom;
    let viewStructureAtom;
    let defaultSelectedOptionAtom;
    let defaultSortSearchOption = Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;

    if (parentPanel === Constant.PANEL_TYPE.HELPDESK_TICKET_LIST) {
        isLoadingAtom = helpdeskTicketListIsLoadingDrillDownDataAtom;
        defaultDrillDownDataAtom = helpdeskTicketListDefaultDrillDownDataAtom;
        drillDownDataAtom = helpdeskTicketListDrillDownDataAtom;
        viewStructureAtom = helpdeskTicketListViewStructureAtom;
        defaultSelectedOptionAtom = helpdeskTicketListDefaultSelectedOptionAtom;
    } else {
        isLoadingAtom = isCustomer
            ? isLoadingHelpdeskDrillDownDataAtom
            : isLoadingProjectInuseDrillDownDataAtom;
        defaultDrillDownDataAtom = isCustomer
            ? helpdeskDefaultDrillDownDataAtom
            : projectInuseDefaultDrillDownDataAtom;
        drillDownDataAtom = isCustomer
            ? helpdeskDrillDownDataAtom
            : projectInuseDrillDownDataAtom;
        viewStructureAtom = isCustomer
            ? helpdeskViewStructureAtom
            : projectInuseViewStructureAtom;
        defaultSelectedOptionAtom = isCustomer
            ? helpdeskDefaultSelectedOptionAtom
            : projectInuseDefaultSelectedOptionAtom;
    }

    const [isLoading, setIsLoading] = useRecoilState(isLoadingAtom);
    const [isLoadingDefaultDrilldown, setIsLoadingDefaultDrilldown] = useRecoilState(isLoadingDefaultDrilldownAtom);

    const [viewStructure, setViewStructure] = useRecoilState(viewStructureAtom);

    const [drillDownData, setDrillDownData] = useRecoilState(drillDownDataAtom);
    const [screenDisplay, setScreenDisplay] = useState(Constant.KNOWLEDGE_SEARCH_SCREEN.DRILLDOWN);

    const defaultDrillDownData = useRecoilValue(defaultDrillDownDataAtom);
    const [optionList, setOptionList] = useState([]);

    const [selectedOptionsExclude, setSelectedOptionsExclude] = useState([]);
    const [selectedOptionsInclude, setSelectedOptionsInclude] = useState([]);
    const defaultSelectedOption = useRecoilValue(defaultSelectedOptionAtom);
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom);
    const [searchTagSuggest, setSearchTagSuggest] = useRecoilState(helpdeskTicketSearchTagSuggestAtom);
    const [searchTagSuggestKnowledge, setSearchTagSuggestKnowledge] = useRecoilState(knowledgeSearchTagSuggestAtom);
    const [searchContainAny, setSearchContainAny] = useRecoilState(helpdeskTicketContainAnyAtom);
    const [searchNotInclude, setSearchNotInclude] = useRecoilState(helpdeskTicketNotIncludeAtom);
    const [searchContainAnyKnowledge, setSearchContainAnyKnowledge] = useRecoilState(knowledgeTicketContainAnyAtom);
    const [searchNotIncludeKnowledge, setSearchNotIncludeKnowledge] = useRecoilState(knowledTicketNotIncludeAtom);
    const viewKnowledgeProjectSelected = useRecoilValue(viewKnowledgeProjectSelectedAtom);
    const currentUserDetail = useRecoilValue(userAtom);
    const selectedProject = useRecoilValue(projectInuseDetailAtom);

    const [isConvertPdf , setIsConvertPdf] = useState(false);
    const [isIncludePdfPage, setIsIncludePdfPage] = useState();

    const [destinationPrjId, setDestinationPrjId] = useRecoilState(destinationPrjIdAtom);

    // argsCommon
    let argsCommon = {
        API: API,
        parentPanel: parentPanel,

        isLoading: isLoading,
        setIsLoading: setIsLoading,

        drillDownData,
        setDrillDownData,

        viewStructure,
        setViewStructure,

        screenDisplay,
        setScreenDisplay,

        lastUserAction,
        setLastUserAction,

        searchTagSuggest,
        setSearchTagSuggest,

        searchTagSuggestKnowledge,
        setSearchTagSuggestKnowledge,

        searchContainAny,
        setSearchContainAny,

        searchNotInclude,
        setSearchNotInclude,

        searchContainAnyKnowledge,
        setSearchContainAnyKnowledge,

        searchNotIncludeKnowledge,
        setSearchNotIncludeKnowledge,

        destinationPrjId,
        setDestinationPrjId,
        userDetail: currentUserDetail,
        projectInuseDetail: selectedProject
    };

    // uef get listTagOption from s3 when open tab SEARCH_OPTION
    useEffect(() => {
        if (tabSelected !== Constant.KNOWLEDGE_SEARCH_SCREEN.SEARCH_OPTION) return;
        if (Utils.isEmptyArray(defaultDrillDownData)) return;
        let getOptionList = getOptionListFromDrillDownData(defaultDrillDownData, viewStructure);
        let listOptionS3 = defaultDrillDownData.filter(option => option.itemListS3Path);
        
        if (Utils.isEmptyArray(listOptionS3) || getOptionList.length > Constant.DRILLDOWN_SUGGEST_OPTION_VISIBLE_SIZE) {
            setOptionList(getOptionList);
            return;
        }
        let isMounted = true;
        setIsLoadingDefaultDrilldown(true);
        listOptionS3 = listOptionS3.map(option => {
            const { child, ...rest } = option; 
            return rest;
        });
        const params = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.DRILLDOWN_GET_SUGGEST_TAG_OPTIONS,
            listOptionS3: listOptionS3,
            limit: Constant.DRILLDOWN_SUGGEST_OPTION_VISIBLE_SIZE,
            lastItem: {},
            clientListId: getOptionList.map(opt => ({id: opt.id, groupId: opt.groupId}))
        };

        getPublicAPI(null, params)
            .then(res => {
                if (!isMounted) return;
                const listSuggestOptions = Utils.convertJSONDataToObject(res?.payload)?.listSuggestOptions || [];
                if (!Utils.isEmptyArray(listSuggestOptions)) {
                    if (!isMounted) return;
                    const merged = [...getOptionList, ...listSuggestOptions];
                    const uniqueList = Array.from(new Map(merged.map(item => [item.id, item])).values());
                    setOptionList(uniqueList);
                } else {
                    setOptionList(getOptionList);
                }
            })
            .catch(err => {
                if (isMounted) {
                    setOptionList(getOptionList);
                    console.log('listOptionS3 err >>> ', err)
                }
            })
            .finally(() => {
                if (isMounted) setIsLoadingDefaultDrilldown(false);
            });

        return () => {
            isMounted = false;
        };
    }, [tabSelected, defaultDrillDownData, viewStructure?.ticketProperty]);

    // Exclude option
    useEffect(() => {
        let currentSelectedOption = convertOptionsDataFromStructure(
            viewStructure.options?.otherFields?.exclude,
            optionList,
            argsCommon,
            'exclude'
        );
        setSelectedOptionsExclude(currentSelectedOption);
        let labelTagNotInclude = []
        for (let i = 0; i < currentSelectedOption.length; i++) {
            const element = currentSelectedOption[i];
            labelTagNotInclude.push(element.label);
        }
        setSearchNotInclude(labelTagNotInclude);
    }, [viewStructure.options?.otherFields?.exclude?.length, defaultDrillDownData]);

    //  Include option
    useEffect(() => {
        let currentSelectedOption = convertOptionsDataFromStructure(
            viewStructure.options?.otherFields?.include,
            optionList,
            argsCommon,
            'include'
        );
        let labelTagContainAny = []
        for (let i = 0; i < currentSelectedOption.length; i++) {
            const element = currentSelectedOption[i];
            labelTagContainAny.push(element.label);
        }
        setSearchContainAny(labelTagContainAny);
        setSelectedOptionsInclude(currentSelectedOption);
    }, [viewStructure.options?.otherFields?.include?.length, defaultDrillDownData]);

    // Check convertPdf in CorpRoot by selectedProject
    useEffect(() => {
        if (!Utils.isEmptyObject(viewKnowledgeProjectSelected)) {
            (
                async () => await Utils.isUsingFunctionService(
                    viewKnowledgeProjectSelected,
                    corporationDetail,
                    'convertPDF',
                    setIsConvertPdf
                )
            ) ()
        }

    }, [viewKnowledgeProjectSelected]);
    
    useEffect(() => {
        setIsIncludePdfPage(viewStructure?.options?.isIncludePdfPage === 1);
    },[viewStructure]);

    const [visibleCount, setVisibleCount] = useState(Constant.DEFAULT_TAGS_VISIBLE_COUNT);

    // render drilldown list
    const renderDrilldownList = () => {
        let drillDownDataClone = drillDownData.map((item, index) => {
            let totalInOrg = !Utils.isEmptyArray(item.childInOrg)
                ? item.childInOrg.reduce((prev, curr) => prev + curr.total, 0)
                : 0;
            let totalOutOrg = !Utils.isEmptyArray(item.childOutOrg)
                ? item.childOutOrg.reduce((prev, curr) => prev + curr.total, 0)
                : 0;
            return {
                ...item,
                totalInOrg,
                totalOutOrg
            };
        });

        drillDownDataClone = drillDownDataClone.map(item => {
            if (
                [
                    Constant.DRILLDOWN_TYPE_TEXT.PRIVATE_BOOKMARK,
                    Constant.DRILLDOWN_TYPE_TEXT.SHARED_BOOKMARK
                ].includes(item.id)
            ) {
                item.itemType = Constant.FORMAT_OPTION_SEARCH.BOOKMARK;
            } else if (item.usage === Constant.DRILLDOWN_USAGE.TAG) {
                const itemSysField = item.sysField || '';
                if (Object.values(Constant.SYS_FIELD).includes(itemSysField)) {
                    item.itemType = Constant.FORMAT_OPTION_SEARCH.SYSTEM_FIELD;
                } else {
                    item.itemType = Constant.FORMAT_OPTION_SEARCH.TAG;
                }
            } else if (Constant.DRILLDOWN_TYPE_TEXT.SETTING_MCP_SERVER === item.id) {
                item.itemType = Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING;
            } else if (item.usage === Constant.DRILLDOWN_USAGE.STATUS) {
                item.itemType = Constant.FORMAT_OPTION_SEARCH.STATUS_DRILLDOWN;
            } else {
                item.itemType = Constant.FORMAT_OPTION_SEARCH.OTHER;
            }

            return item;
        });

        const handleSeeMore = currentTagItems => {
            if (visibleCount >= currentTagItems.length) {
                // see-less
                setVisibleCount(Constant.DEFAULT_TAGS_VISIBLE_COUNT);
                return;
            }
            // see-more
            setVisibleCount(prev =>
                Math.min(prev + Constant.DEFAULT_TAGS_VISIBLE_COUNT, drillDownDataClone?.length)
            );
        };

        

        return (
            <>
                {drillDownDataClone.slice(0, visibleCount).map((item) => {
                    switch (item.itemType) {
                        case Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING:
                            return (
                                !isSelectedDrilldownField(item, viewStructure) && (
                                    <TreeView
                                        defaultCollapseIcon={<ArrowDropDownIcon />}
                                        defaultExpandIcon={<ArrowRightIcon />}
                                        disableselection="true"
                                        key={item.id}
                                    >
                                        <TreeItem
                                            nodeId={item.id}
                                            label={`${item.label} ${
                                                item.total ? `(${item.total})` : ''
                                            }`}
                                            disableselection="true"
                                        >
                                            {!Utils.isEmptyArray(item.child) &&
                                                renderDrillDownItemList(item.child, item)}
                                        </TreeItem>
                                    </TreeView>
                                )
                            );
                        case Constant.FORMAT_OPTION_SEARCH.BOOKMARK:
                            return (
                                !isSelectedDrilldownField(item, viewStructure) && (
                                    <TreeView
                                        defaultCollapseIcon={<ArrowDropDownIcon />}
                                        defaultExpandIcon={<ArrowRightIcon />}
                                        disableselection="true"
                                        key={item.id}
                                    >
                                        <TreeItem
                                            nodeId={item.id}
                                            label={`${getDrilldownParentDisplayLabel(item)} ${
                                                item.total ? `(${item.total})` : ''
                                            }`}
                                            disableselection="true"
                                        >
                                            {!Utils.isEmptyArray(item.child) &&
                                                renderDrillDownItemList(item.child, item)}
                                        </TreeItem>
                                    </TreeView>
                                )
                            );

                        case Constant.FORMAT_OPTION_SEARCH.STATUS_DRILLDOWN:
                            return (
                                !isSelectedDrilldownField(item, viewStructure) && (
                                    <TreeView
                                        defaultCollapseIcon={<ArrowDropDownIcon />}
                                        defaultExpandIcon={<ArrowRightIcon />}
                                        disableselection="true"
                                        key={item.id}
                                    >
                                        <TreeItem
                                            nodeId={item.id}
                                            label={`${getDrilldownParentDisplayLabel(item)} ${
                                                item.total ? `(${item.total})` : ''
                                            }`}
                                            disableselection="true"
                                        >
                                            {!Utils.isEmptyArray(item.child) &&
                                                renderDrillDownItemList(item.child, item)}
                                        </TreeItem>
                                    </TreeView>
                                )
                            );
                        case Constant.FORMAT_OPTION_SEARCH.SYSTEM_FIELD:
                        case Constant.FORMAT_OPTION_SEARCH.TAG:
                            return !isSelectedDrilldownField(item, viewStructure) && (<RenderDrilldownTag tagItem={item} argsCommon={argsCommon} />);
                        case Constant.FORMAT_OPTION_SEARCH.OTHER:
                            return (
                                !isSelectedDrilldownField(item, viewStructure) && (
                                    <TreeView
                                        defaultCollapseIcon={<ArrowDropDownIcon />}
                                        defaultExpandIcon={<ArrowRightIcon />}
                                        disableselection="true"
                                        key={item.id}
                                    >
                                        <TreeItem
                                            nodeId={item.id}
                                            label={`${item.label} ${
                                                item.total ? `(${item.total})` : ''
                                            }`}
                                            disableselection="true"
                                        >
                                            {!Utils.isEmptyArray(item.child) &&
                                                renderDrillDownItemList(item.child, item)}

                                            {['projectOrigin', 'projectTarget'].includes(item.id) &&
                                                !Utils.isEmptyArray(item.childInOrg) && (
                                                    <TreeItem
                                                        nodeId={item.id + '-childInOrg'}
                                                        label={`${trI18n('USER04BTN007')} (${
                                                            item.totalInOrg
                                                        })`}
                                                        disableselection="true"
                                                    >
                                                        {renderDrillDownItemList(
                                                            item.childInOrg,
                                                            item,
                                                            'childInOrg'
                                                        )}
                                                    </TreeItem>
                                                )}

                                            {['projectOrigin', 'projectTarget'].includes(item.id) &&
                                                !Utils.isEmptyArray(item.childOutOrg) && (
                                                    <TreeItem
                                                        nodeId={item.id + '-childOutOrg'}
                                                        label={`${trI18n('USER04BTN031')} (${
                                                            item.totalOutOrg
                                                        })`}
                                                        disableselection="true"
                                                    >
                                                        {renderDrillDownItemList(
                                                            item.childOutOrg,
                                                            item,
                                                            'childOutOrg'
                                                        )}
                                                    </TreeItem>
                                                )}

                                            {item.id === 'noticeTargetUser' &&
                                                !Utils.isEmptyArray(item.childInOrg) && (
                                                    <TreeItem
                                                        nodeId={item.id + '-childInOrg'}
                                                        label={`${trI18n('USER04BTN034')} (${
                                                            item.totalInOrg
                                                        })`}
                                                        disableselection="true"
                                                    >
                                                        {renderDrillDownItemList(
                                                            item.childInOrg,
                                                            item,
                                                            'childInOrg'
                                                        )}
                                                    </TreeItem>
                                                )}

                                            {item.id === 'noticeTargetUser' &&
                                                !Utils.isEmptyArray(item.childOutOrg) && (
                                                    <TreeItem
                                                        nodeId={item.id + '-childOutOrg'}
                                                        label={`${trI18n('USER04BTN033')} (${
                                                            item.totalOutOrg
                                                        })`}
                                                        disableselection="true"
                                                    >
                                                        {renderDrillDownItemList(
                                                            item.childOutOrg,
                                                            item,
                                                            'childOutOrg'
                                                        )}
                                                    </TreeItem>
                                                )}
                                        </TreeItem>
                                    </TreeView>
                                )
                            );
                        default:
                            return null;
                    }
                })}

                {drillDownDataClone.length > Constant.DEFAULT_TAGS_VISIBLE_COUNT && (
                    <button
                        className="showMore-btn-drilldown"
                        onClick={() => handleSeeMore(drillDownDataClone)}
                    >
                        {visibleCount >= drillDownDataClone.length
                            ? trI18n('COMBTN010')
                            : trI18n('COMBTN009')}
                    </button>
                )}
            </>
        );
    };

    // Child labels are resolved centrally by getDrilldownChildDisplayLabel().

    const renderDrillDownItemList = (itemChildList, item, type) => {
        let listItem = [];
        let isShowingItem = item.isShowMore;

        switch (type) {
            case 'childInOrg':
                isShowingItem = item.isShowMoreChildInOrg;
                break;
            case 'childOutOrg':
                isShowingItem = item.isShowMoreChildOutOrg;
                break;
            default:
                break;
        }

        for (let itemChild of itemChildList) {
            if (!isSelectedOption(viewStructure, item, itemChild.id)) {
                const childLabel = getDrilldownChildDisplayLabel(item, itemChild);
                // Create label text
                const labelText = itemChild.total
                    ? `${childLabel} (${itemChild.total})`
                    : childLabel;
                
                listItem.push(
                    <TreeItem
                        className='itemIcon'
                        nodeId={itemChild.id}
                        label={<OverFlowTooltipWithTabsMui value={labelText} />}
                        disableselection="true"
                        onClick={e => selectDrilldown(argsCommon, item, itemChild)}
                        icon={<LensIcon fontSize='small' />}
                        key={itemChild.id}
                    />
                );
            }
        }

       

        if (listItem.length > Constant.DEFAULT_TAGS_VISIBLE_COUNT) {
            if (!isShowingItem) {
                listItem = listItem.slice(0, Constant.DEFAULT_TAGS_VISIBLE_COUNT);
                listItem.push(
                    <button
                        className="showMore-btn-drilldown"
                        onClick={e => showAllDrillDownItem(true, argsCommon, item, type)}
                    >
                        {trI18n('COMBTN009')}
                    </button>
                );
            } else {
                listItem.push(
                    <button
                        className="showMore-btn-drilldown"
                        onClick={e => showAllDrillDownItem(false, argsCommon, item, type)}
                    >
                        {trI18n('COMBTN010')}
                    </button>
                );
            }
        }

        return listItem;
    };

    // render search option
    const renderSearchOption = () => {
        const defaultMaterialTheme = createTheme({
            palette: {
                primary: indigo
            }
        });

        const currentSearchDateType =
            viewStructure.options.hasOwnProperty('searchDateType') &&
            viewStructure.options.searchDateType === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO
                ? Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO
                : Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.RANGE;

        const onChangeTime = (e, type) => {
            let currentViewStructure = cloneDeep(viewStructure);

            if (e) {
                let dateValue = e.format('YYYY/MM/DD');
                if (type === 'from') {
                    currentViewStructure.options['from'] = dateValue;
                } else {
                    currentViewStructure.options['to'] = dateValue;
                }

                // Switch from and to if from > to
                if (dateValue !== 'Invalid date') {
                    let fromSearchDate = currentViewStructure.options['from'];
                    let toSearchDate = currentViewStructure.options['to'];
                    if (fromSearchDate && toSearchDate && fromSearchDate > toSearchDate) {
                        currentViewStructure.options.from = toSearchDate;
                        currentViewStructure.options.to = fromSearchDate;
                    }
                }
                setViewStructure(currentViewStructure);
            } else {
                // Remove date
                if (type === 'from') {
                    currentViewStructure.options['from'] = null;
                } else {
                    currentViewStructure.options['to'] = null;
                }
                setViewStructure(currentViewStructure);
            }
        };

        const onBlurDateInput = (e, type) => {
            let dateTyping = e.target.value;
            let currentViewStructure = cloneDeep(viewStructure);
            let formatedDate = null;

            if (dateTyping && dateTyping !== '____/__/__') {
                let convertDateTyping = moment(dateTyping).format('YYYY/MM/DD');
                if (
                    convertDateTyping !== 'Invalid date' &&
                    moment(dateTyping, 'YYYY/MM/DD', true).isValid()
                ) {
                    formatedDate = convertDateTyping;
                } else {
                    dateTyping = dateTyping.replaceAll('_', '');
                    const [typingYear, typingMonth, typingDay] = dateTyping.split('/');
                    if (typingYear && parseInt(typingYear) !== 0 && parseInt(typingYear) >= 1970) {
                        let convertedYear = `0000${parseInt(typingYear)}`;
                        let convertedMonth =
                            typingMonth && parseInt(typingMonth) !== 0
                                ? `00${parseInt(typingMonth)}`
                                : '01';
                        let convertedDay =
                            typingDay && parseInt(typingDay) !== 0
                                ? `00${parseInt(typingDay)}`
                                : '01';

                        // Get last 4/2 character to pass date format
                        convertedYear = convertedYear.substring(convertedYear.length - 4);
                        convertedMonth = convertedMonth.substring(convertedMonth.length - 2);
                        convertedDay = convertedDay.substring(convertedDay.length - 2);

                        formatedDate = `${convertedYear}/${convertedMonth}/${convertedDay}`;

                        if (!moment(formatedDate, 'YYYY/MM/DD', true).isValid()) {
                            formatedDate = null;
                        }
                    }
                }
            }

            if (type === 'from') {
                currentViewStructure.options['from'] = formatedDate ? formatedDate : null;
            } else {
                currentViewStructure.options['to'] = formatedDate ? formatedDate : null;
            }

            // Switch from and to date if from date > to date
            let fromSearchDate = currentViewStructure.options['from'];
            let toSearchDate = currentViewStructure.options['to'];
            if (fromSearchDate && toSearchDate && fromSearchDate > toSearchDate) {
                currentViewStructure.options.from = toSearchDate;
                currentViewStructure.options.to = fromSearchDate;
            }
            setViewStructure(currentViewStructure);
        };

        const onChangeDateAgoValue = method => {
            let currentViewStructure = cloneDeep(viewStructure);
            let currentDateAgoValue = currentViewStructure.options?.searchDateAgoValue
                ? parseInt(currentViewStructure.options?.searchDateAgoValue)
                : Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_VALUE;

            if (method === 'up') {
                currentDateAgoValue += 1;
            } else if (method === 'down') {
                currentDateAgoValue -= 1;
            }

            if (currentDateAgoValue < 0) {
                currentDateAgoValue = 0;
            } else if (currentDateAgoValue > 9999) {
                currentDateAgoValue = 9999;
            }

            let newValue = parseInt(currentDateAgoValue);
            currentViewStructure.options.searchDateAgoValue = newValue;
            argsCommon?.setViewStructure(currentViewStructure);
        };

        const isShowOptionSortSimilar = () => {
            if (parentPanel === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST && isCheckMethodSimilar(viewStructure)) {
                return true;
            }
            return false;
        }

        const isShowOptionPageNo = () => {
            if (parentPanel === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST && isCheckSortPageNo(viewStructure)) {
                return true;
            }
            return false;
        }

        const handleRenderViewValue = (isConvertedPdf) => {
            if (!isConvertedPdf && viewStructure?.options['sort'] === Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.PAGE_NO) {
                return Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT
            }

            return viewStructure.options['sort']
                ? viewStructure.options['sort']
                : defaultSortSearchOption
        }

        return (
            <>
                {/* Search time */}
                <div className="searchOption-title">{trI18n('DRILLB004')}</div>
                <div className="content-padding">
                    <div className="switch-check">
                        <input
                            type="checkbox"
                            id="recently"
                            value={currentSearchDateType}
                            defaultChecked={
                                currentSearchDateType ===
                                Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO
                            }
                            checked={
                                currentSearchDateType ===
                                Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO
                            }
                        />

                        <label htmlFor="recently" onClick={e => onChangeSearchDateType(argsCommon)}>
                            <span className="switch-text">{trI18n('DRILLB001')}</span>
                        </label>
                    </div>

                    {currentSearchDateType === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.RANGE && (
                        <div className="searchOption-time">
                            <div className="formTime">
                                <div className="itemDatePicker">
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <ThemeProvider theme={defaultMaterialTheme}>
                                            <KeyboardDatePicker
                                                TextFieldComponent={TextField}
                                                key="field-date-picker-from"
                                                className="field-date-picker form-control-wrapPicker form-control-hg40"
                                                placeholder={tr('（指定なし）')}
                                                minDate={new Date('1970/01/01')}
                                                defaultValue={
                                                    viewStructure.options['from']
                                                        ? viewStructure.options['from']
                                                        : null
                                                }
                                                value={
                                                    viewStructure.options['from']
                                                        ? viewStructure.options['from']
                                                        : null
                                                }
                                                InputLabelProps={{
                                                    className: '',
                                                    required: false
                                                }}
                                                inputVariant="outlined"
                                                format="YYYY/MM/DD"
                                                onChange={e => onChangeTime(e, 'from')}
                                                error={false}
                                                helperText={null}
                                                onBlur={e => onBlurDateInput(e, 'from')}
                                                onPaste={e => e.preventDefault()}
                                                onFocus={e => e.preventDefault()}
                                            />
                                        </ThemeProvider>
                                    </MuiPickersUtilsProvider>
                                    <Button
                                        className="close-DatePicker"
                                        onClick={e => removeTypingDate('from', argsCommon)}
                                    >
                                        <img src="/assets/image/icon-close-datetime.svg" alt="" />
                                    </Button>
                                </div>
                            </div>
                            <div className="formTime">
                                <div className="itemDatePicker">
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <ThemeProvider theme={defaultMaterialTheme}>
                                            <KeyboardDatePicker
                                                TextFieldComponent={TextField}
                                                key="field-date-picker-to"
                                                className="field-date-picker form-control-wrapPicker form-control-hg40"
                                                placeholder={tr('（指定なし）')}
                                                minDate={new Date('1970/01/01')}
                                                defaultValue={
                                                    viewStructure.options['to']
                                                        ? moment(viewStructure.options['to'])
                                                        : null
                                                }
                                                value={
                                                    viewStructure.options['to']
                                                        ? viewStructure.options['to']
                                                        : null
                                                }
                                                InputLabelProps={{
                                                    className: '',
                                                    required: false
                                                }}
                                                inputVariant="outlined"
                                                format="YYYY/MM/DD"
                                                onChange={e => onChangeTime(e, 'to')}
                                                error={false}
                                                helperText={null}
                                                onBlur={e => onBlurDateInput(e, 'to')}
                                                onPaste={e => e.preventDefault()}
                                                onFocus={e => e.preventDefault()}
                                            />
                                        </ThemeProvider>
                                    </MuiPickersUtilsProvider>
                                    <Button
                                        className="close-DatePicker"
                                        onClick={e => removeTypingDate('to', argsCommon)}
                                    >
                                        <img src="/assets/image/icon-close-datetime.svg" alt="" />
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}

                    {currentSearchDateType === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO && (
                        <div className="searchOption-time">
                            <div className="formTime formTime-number">
                                <TextField
                                    id="search-option-date-ago-value"
                                    key="search-option-date-ago-value"
                                    className="form-control-wrapInput form-control-hg40"
                                    variant="outlined"
                                    type="number"
                                    value={
                                        viewStructure.options?.searchDateAgoValue
                                            ? parseInt(
                                                  viewStructure.options?.searchDateAgoValue
                                              ).toString()
                                            : Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_VALUE.toString()
                                    }
                                    onChange={e => handleChangeSearchDateAgoValue(e, argsCommon)}
                                    onKeyPress={event => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                                <div className="formButton">
                                    <Button
                                        className="btnNumber up"
                                        onClick={e => onChangeDateAgoValue('up')}
                                    >
                                        <img src="/assets/image/icon-arrow-nav.svg" alt="" />
                                    </Button>
                                    <Button
                                        className="btnNumber down"
                                        onClick={e => onChangeDateAgoValue('down')}
                                    >
                                        <img src="/assets/image/icon-arrow-nav.svg" alt="" />
                                    </Button>
                                </div>
                            </div>
                            <div className="formTime">
                                <Select
                                    id="search-option-date-ago-unit"
                                    key="search-option-date-ago-unit"
                                    className="form-control--selectControl form-control--hg40"
                                    variant="outlined"
                                    value={
                                        viewStructure.options?.searchDateAgoUnit
                                            ? viewStructure.options?.searchDateAgoUnit
                                            : Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY
                                    }
                                    onChange={e => handleChangeSearchDateAgoUnit(e, argsCommon)}
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left'
                                        },
                                        transformOrigin: {
                                            vertical: 'top',
                                            horizontal: 'left'
                                        },
                                        getContentAnchorEl: null,
                                        className: 'selectDrop'
                                    }}
                                >
                                    <MenuItem
                                        value={Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY}
                                    >
                                        {trI18n('DRILLB002')}
                                    </MenuItem>
                                    <MenuItem
                                        value={Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK}
                                    >
                                        {trI18n('DRILLB003')}
                                    </MenuItem>
                                </Select>
                            </div>
                        </div>
                    )}
                </div>

                {/* Tag/ search option / include / exclude */}
                <div className="searchOption-title">{trI18n('DRILLB007')}</div>
                <div className="search-option-tag content-padding">
                    <div className="search-option-tag-child">
                        <label className="search-option-tag-label">{trI18n('LABEL_DEFAULT_OPTION_TAG')}</label>
                        <div className="search-option-tag-input search-option-default-tag-input">
                            <Autocomplete
                                multiple
                                className="search-option-tag-content"
                                PopperComponent={({ style, ...props1 }) => (
                                    <Popper
                                        {...props1}
                                        style={{ ...style }} // width is passed in 'style' prop
                                        className="selectDrop"
                                    />
                                )}
                                // freeSolo
                                disabled
                                disableClearable
                                sx={{
                                    maxHeight: 10
                                }}
                                options={defaultSelectedOption}
                                getOptionLabel={option =>
                                    getSelectedDrilldownOptionDisplayLabel(option)
                                }
                                getOptionSelected={(option, selectedValue) =>
                                    option.fieldLabel === selectedValue.fieldLabel &&
                                    option.itemLabel === selectedValue.itemLabel
                                }
                                filterOptions={(options, state) => {
                                    const keyword = normalizeString(state.inputValue);
                                    return options.filter(option =>
                                        normalizeString(option.label).includes(keyword)
                                    );
                                }}
                                value={defaultSelectedOption}
                                onChange={(e, newValue) => e.preventDefault()}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        className="form-control"
                                    />
                                )}
                            />
                        </div>
                    </div>

                    <div className="search-option-tag-child">
                        <label className="search-option-tag-label">{trI18n('LABEL_INCLUDE_OPTION_TAG')}</label>
                        <RenderAutoCompleted
                            optionType='include'
                            optionList={optionList.filter(option =>
                                !selectedOptionsInclude.find(selected => selected.id === option.id)
                            )}
                            setOptionList={setOptionList}
                            selectedOptionsValue={selectedOptionsInclude}
                            argsCommon={argsCommon}
                            defaultDrillDownData={defaultDrillDownData}
                        />
                    </div>

                    <div className="search-option-tag-child">
                        <label className="search-option-tag-label">{trI18n('LABEL_EXCLUDE_OPTION_TAG')}</label>
                        <RenderAutoCompleted
                            optionType='exclude'
                            optionList={optionList.filter(option =>
                                !selectedOptionsExclude.find(selected => selected.id === option.id)
                            )}
                            setOptionList={setOptionList}
                            selectedOptionsValue={selectedOptionsExclude}
                            argsCommon={argsCommon}
                            defaultDrillDownData={defaultDrillDownData}
                        />
                    </div>
                </div>

                {/* Sort */}
                <div className="searchOption-title">{trI18n('DRILLB008')}</div>
                <div className="search-option-sort">
                    <label className="search-option-tag-label">{trI18n('DRILLB009')}</label>
                    <div className="searchSort">
                        <Select
                            className="form-control--selectControl form-control--hg40"
                            variant="outlined"
                            defaultValue={Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT}
                            value={handleRenderViewValue(isConvertPdf)}
                            onChange={e => handleChangeSortType(e, argsCommon)}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }}
                            disabled={
                                isCheckMethodSimilar(viewStructure) ||
                                isCheckSortPageNo(viewStructure)
                            }
                            disableClearable={
                                isCheckMethodSimilar(viewStructure) ||
                                isCheckSortPageNo(viewStructure)
                            }
                        >
                            <MenuItem value={Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.CREATED_AT}>
                                {tr(Constant.KNOWLEDGE_SORT_TYPE.CREATED_AT)}
                            </MenuItem>
                            <MenuItem value={Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT}>
                                {tr(Constant.KNOWLEDGE_SORT_TYPE.UPDATED_AT)}
                            </MenuItem>
                            {isShowOptionSortSimilar() && (
                                <MenuItem
                                    value={Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.SIMILAR}
                                >
                                    {tr(Constant.KNOWLEDGE_SORT_TYPE.SIMILAR)}
                                </MenuItem>
                            )}
                            {isShowOptionPageNo() && (
                                <MenuItem
                                    value={Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.PAGE_NO}
                                >
                                    {tr(Constant.KNOWLEDGE_SORT_TYPE.PAGE_NO)}
                                </MenuItem>
                            )}

                            <MenuItem
                                value={
                                    Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE
                                        .SORT_TOTAL_PRIVATE_BOOKMARK_DESC
                                }
                            >
                                {tr(Constant.KNOWLEDGE_SORT_TYPE.TOTAL_PRIVATE_BOOKMARK_DESC)}
                            </MenuItem>
                            <MenuItem
                                value={
                                    Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE
                                        .SORT_TOTAL_PRIVATE_BOOKMARK_ASC
                                }
                            >
                                {tr(Constant.KNOWLEDGE_SORT_TYPE.TOTAL_PRIVATE_BOOKMARK_ASC)}
                            </MenuItem>
                        </Select>
                    </div>
                </div>

                {/* Option show file, page knowledge */}
                {isDisplayIconSearchFileAndPageKnowledge(
                    corporationDetail,
                    viewStructure,
                    parentPanel
                ) && (
                    <div className="div">
                        <div className="searchOption-title file-page-knowledge">
                            {trI18n('LABEL-OPTION-FILE_PAGE_KNOWLEDGE')}
                        </div>
                        <div className="checkbox-search-pdf">
                            <div className="search-item">
                                <input
                                    type="checkbox"
                                    id={`checkbox-include-page-pdf`}
                                    defaultChecked={isIncludePdfPage}
                                    checked={isIncludePdfPage}
                                    className="search-include-page-pdf"
                                    onClick={e => {
                                        setIsIncludePdfPage(e.target.checked);
                                        handleChangeSearchPdfOption(
                                            e.target.checked,
                                            'isIncludePdfPage',
                                            {
                                                viewStructure,
                                                setViewStructure
                                            }
                                        );
                                    }}
                                    disabled={
                                        viewStructure?.options?.method ===
                                        Constant.SETTING_SEARCH_KEYWORD.SIMILAR
                                    }
                                />
                                <label
                                    className={`label-search-pdf-drilldown ${
                                        viewStructure?.options?.method ===
                                        Constant.SETTING_SEARCH_KEYWORD.SIMILAR
                                            ? 'search-synonym-disable'
                                            : ''
                                    }`}
                                    htmlFor={`checkbox-include-page-pdf`}
                                >
                                    {trI18n('LABEL-INCLUDE_PDF_PAGE')}
                                </label>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };

    return (
        <div className="mainWrap knowledgeSearchSetting">
            <LoadingPanel isLoading={isLoading || isLoadingDefaultDrilldown} />
            <div className="mainTop">
                <div className="tabList-HelpDesk">
                    <div className="navTabs">
                        <AppBar className="navTabs-box" position="static">
                            <Tabs
                                className="navTabs-rot"
                                value={tabSelected}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="scrollable auto tabs example"
                                onChange={onChangeTab}
                            >
                                <Tab
                                    className="navTabs--item custom-tab"
                                    label={trI18n('LABEL_DRILLDOWN_SEARCH')}
                                    value={Constant.KNOWLEDGE_SEARCH_SCREEN.DRILLDOWN}
                                />
                                <Tab
                                    className="navTabs--item custom-tab"
                                    label={trI18n('LABEL_SEARCH_OPTION')}
                                    value={Constant.KNOWLEDGE_SEARCH_SCREEN.SEARCH_OPTION}
                                />
                            </Tabs>
                        </AppBar>
                    </div>
                </div>
            </div>

            {tabSelected === Constant.KNOWLEDGE_SEARCH_SCREEN.DRILLDOWN && (
                <div className="scrollBar-main change-bodR drillDownListBody">
                    {!isLoading && !Utils.isEmptyArray(drillDownData) && renderDrilldownList()}
                    {!isLoading && Utils.isEmptyArray(drillDownData) && (
                        <div className="listEmpty listEmpty-qa">
                            <span className="listEmpty-item">
                                <img src="/assets/image/icon-listEmpty.svg" alt="" />
                            </span>
                            {trI18n('COMMSG001')}
                        </div>
                    )}
                </div>
            )}

            {tabSelected === Constant.KNOWLEDGE_SEARCH_SCREEN.SEARCH_OPTION && (
                <div className="scrollBar-main change-bodR searchOptionBody">
                    {renderSearchOption()}
                </div>
            )}
        </div>
    );
}

DrilldownAndDetailSearch.prototype = {
    parentPanel: PropTypes.any,
    isCustomer: PropTypes.any,
    API: PropTypes.any,
}
